import Swal from 'sweetalert2';

export const checkNoteStatus = async (noteId) => {
  const noteResponse = await fetch(`/api/get-note/${noteId}`, {
    method: 'GET',
    credentials: 'include'
  });

  if (!noteResponse.ok) {
    throw new Error('Erreur lors de la récupération de la note');
  }

  const noteData = await noteResponse.json();

  if (noteData.statut === 'payee') {
    await Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: 'Vous ne pouvez pas ajouter de dépense à une note déjà payée.',
      confirmButtonText: 'OK'
    });
    return false;
  }

  return true;
};

export const submitExpense = async (formData) => {
  try {
    Swal.fire({
      title: 'En cours...',
      text: 'Ajout de la dépense en cours, veuillez patienter.',
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const response = await fetch('/api/add-expense', {
      method: 'POST',
      body: formData,
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Erreur lors de l\'ajout de la dépense');
    }

    const data = await response.json();
    Swal.close();

    return { success: true, data };
  } catch (error) {
    console.error('Erreur:', error);
    await Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: 'Une erreur est survenue lors de l\'ajout de la dépense',
      confirmButtonText: 'OK'
    });
    return { success: false, error };
  }
}; 
